export * from './lib/hosted-auth';

export { default as MockProviderIcon } from './lib/icon.svg';
export const mockName = 'Testing';
